import './NavExperts.scss';
import React from 'react';
import { useState } from 'react';
import Slider from 'react-slick';



function NavExperts({ onItemChage, navLinks, currentCategory }) {

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
  
    slidesToScroll: 1,
     responsive: [
        {
          breakpoint: 1334,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 880,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            initialSlide: 2,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 724,
          settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false
          }
        },
        {
          breakpoint: 550,
          settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false
          }
        },
        {
          breakpoint: 428,
          settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false
          }
        },
        {
          breakpoint: 360,
          settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false
          }
        }
      ]
  };

  const [isActive, setIsActive] = useState('webDev');

  const navItem = navLinks.map((item) => {
  
    return (<div className="navlink" key={item.key} >
      <button className={`${item.key === isActive ? 'active': ''} ${item.key === isActive ? 'button-active': ''}`} key={item.key} onClick={() => {
        onItemChage(item.key);
        setIsActive(item.key);
      }
      }>{item.title}</button>
    </div>)
  }
  )

  return (
    <div className="experts-button-wrapper">
      <Slider {...settings}>
        {navItem}
      </Slider>
    </div>
  );
}

export default NavExperts;